import { render } from "./DateChangeActivityBadge.vue?vue&type=template&id=b51b634a&scoped=true"
import script from "./DateChangeActivityBadge.vue?vue&type=script&lang=js"
export * from "./DateChangeActivityBadge.vue?vue&type=script&lang=js"

import "./DateChangeActivityBadge.vue?vue&type=style&index=0&id=b51b634a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b51b634a"

export default script